import React from "react";
import { Box, Text, Button, VStack, Icon } from "@chakra-ui/react";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const PaymentSuccess = ({ orderId = "",name ,email}) => {
  const navigate=useNavigate()
  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-br, green.100, green.50)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      px={4}
      
    >

      <Box
        bg="white"
        p={8}
        rounded="2xl"
        shadow="lg"
        maxW="lg"
        w={["100%", "90%", "80%"]}
        textAlign="center"
      >
        <Icon as={CheckCircleIcon} boxSize={16} color="green.400" mb={4} />
        <Text fontSize="2xl" fontWeight="bold" color="green.600">
          Payment Successful
        </Text>

        <Text mt={2} color="gray.600">
          Thank you, {name|| "User"}!
        </Text>

        <Box mt={4} bg="gray.50" p={4} rounded="md">
          <Text fontSize="sm" color="gray.500">
            Order ID
          </Text>
          {
            orderId && <Text fontWeight="semibold">{orderId}</Text>
          }
          
         { email && <p>Your email: {email}</p> }
        </Box>

        <VStack spacing={3} mt={6}>
          <Button onClick={navigate("/Agent-Generation")} colorScheme="green" width="full">
            Go to Dashboard
          </Button>
          {/* <Button variant="outline" colorScheme="green" width="full">
            Download Invoice
          </Button> */}
        </VStack>
      </Box>
    </Box>
  );
};

export default PaymentSuccess;
